import { modifier } from 'ember-modifier';

export default modifier(function onArgsChange(_element, [fn, ...deps]) {
  if (typeof fn === 'function') {
    fn(...deps);
  }
});
